import type {
  GameMentorsOrganization,
  GameMentorsPerson,
  GameMentorsWebSite,
  JsonLdSchema,
} from '../types/schema';

export const generateJsonLd = (data: JsonLdSchema): string => {
  return JSON.stringify(data);
};

export const createOrganizationLd = (): GameMentorsOrganization => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'GameMentors',
  url: 'https://gamementors.be',
  description: 'Professional gaming mentorship platform connecting players with expert mentors',
});

export const createWebsiteLd = (): GameMentorsWebSite => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'GameMentors',
  url: 'https://gamementors.be',
  description:
    'Find your perfect gaming mentor and level up your skills with professional guidance',
  publisher: createOrganizationLd(),
});

export const createPersonLd = (
  name: string,
  url: string,
  image?: string,
  description?: string,
  jobTitle?: string,
  sameAs?: string[]
): GameMentorsPerson => ({
  '@context': 'https://schema.org',
  '@type': 'Person',
  name,
  url,
  ...(image && { image }),
  ...(description && { description }),
  ...(jobTitle && { jobTitle }),
  ...(sameAs && { sameAs }),
});

export const createMentorListLd = (
  mentors: Array<{
    id: string;
    name: string;
    image?: string;
    description?: string;
    expertise?: string[];
  }>
) => ({
  '@context': 'https://schema.org' as const,
  '@type': 'ItemList' as const,
  itemListElement: mentors.map((mentor, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: createPersonLd(
      mentor.name,
      `https://gamementors.be/mentors/${mentor.id}`,
      mentor.image,
      mentor.description,
      mentor.expertise?.[0]
    ),
  })),
});
